module.exports = __webpack_public_path__ + "img/blue.cb996fa2.png";